import { Ok, Result } from 'ts-res';
import { KameleoonData } from 'src/kameleoonData/types';
import { KameleoonError } from 'src/kameleoonError';
import { EvaluationDataType } from 'src/targeting/types';
import { ConditionDataType, ICondition } from './types';

export class ConversionLikelihood implements ICondition {
  private lowerBound?: number;
  private upperBound?: number;
  private keyMomentId?: number;
  private goalId?: number | null;

  constructor({
    lowerBound,
    upperBound,
    keyMomentId,
    goalId,
  }: ConditionDataType) {
    this.lowerBound = lowerBound;
    this.upperBound = upperBound;
    this.keyMomentId = keyMomentId;
    this.goalId = goalId;
  }

  public evaluate({
    targetingData,
  }: EvaluationDataType): Result<boolean, KameleoonError> {
    const kcsData = targetingData?.[KameleoonData.KameleoonConversionScore];

    if (
      typeof this.keyMomentId !== 'number' ||
      typeof this.goalId !== 'number' ||
      typeof this.lowerBound !== 'number' ||
      typeof this.upperBound !== 'number' ||
      !kcsData
    ) {
      return Ok(false);
    }

    const score: number | undefined =
      kcsData.kcs[this.keyMomentId.toString()]?.[this.goalId.toString()];

    if (typeof score !== 'number') {
      return Ok(false);
    }

    return Ok(score >= this.lowerBound && score <= this.upperBound);
  }
}
